/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1904279553 — Відновлення сесії після перезавантаження */

/**
 * Persist the active order id in the URL via history.replaceState so that
 * a browser reload (which keeps the URL but clears in-memory React state)
 * lands the next mount in the recovery path instead of issuing a fresh
 * /api/connect. Connecting.tsx writes the id immediately after a successful
 * handshake; the reload-recovery hook then reads it back on next mount.
 */
export const persistOrderIdInUrl = (orderId: string | number): void => {
    const url = new URL(window.location.href);
    url.searchParams.set('oid', String(orderId));
    window.history.replaceState(null, '', url.toString());
};
